import { Stack, Typography } from "@mui/material";
import { CheckmarkCircle02Icon, CircleIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Feature } from "@/types/plans";

const FeatureDetail = ({ label, value, status }: Feature) => (
  <Stack direction="row" justifyContent="space-between" alignItems="center">
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>

    {status === "enabled" && (
      <HugeiconsIcon
        icon={CheckmarkCircle02Icon}
        color="#4CAF50"
        fontSize="small"
        style={{
          alignItems: "flex-end",
        }}
      />
    )}
    {status === "disabled" && <HugeiconsIcon icon={CircleIcon} color="#9E9E9E" />}
    {!status && (
      <Typography variant="body1" sx={{ alignItems: "flex-end" }}>
        {value}
      </Typography>
    )}
  </Stack>
);

export default FeatureDetail;
